import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchCertificateContentPageAction } from './actions/fetchCertificateContentPage';

import {CertificatesPage} from './certificatesPage';

const mapStateToProps = (state: IState) => ({
    certificateContentPage: state.mainContent.certificatesPageItem
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchCertificateContentPage: () => dispatch(fetchCertificateContentPageAction())
});

export const CertificatesPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CertificatesPage);


// WEBPACK FOOTER //
// ./src/components/certificatesPage/certificatesPageContainer.tsx